import { Link, useLocation } from 'react-router-dom';
import { Stack, Typography } from '@mui/material';
import ErrorIcon from '@mui/icons-material/Error';

import { MainContainer } from 'pages/ConfirmEmail/styles';
import DefaultWrapper from 'shared-components/DefaultWrapper';

const NotFound = () => {
  const { pathname } = useLocation();

  return (
    <DefaultWrapper
      showHeader={true}>
      <MainContainer>
        <Stack
          sx={{ alignItems: 'center' }}>
          <ErrorIcon
            sx={{ fontSize: 60, mb: 2 }}
          />
          <Typography
            textAlign='center' color='textSecondary'>
            The page <b>{pathname}</b> you are trying to access was not found.
            Go back to{' '}
            <Link
              to='/homepage'>
              <b>homepage.</b>
            </Link>
          </Typography>
        </Stack>
      </MainContainer>
    </DefaultWrapper>
  );
};

export default NotFound;
